import { Button, Col, Modal, Row, Tooltip, Dropdown, Icon, Menu } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addFilter, createShipment, deleteOrder } from '../../actions/ordersAction.js';
import { orderStatus, FulfillOption } from './../../constants';
import AddFilter from './../../containers/orders/components/add-filter';
import addOrderDis from './../../resources/assets/images/addOrderDisable.png';
import addOrderEna from './../../resources/assets/images/addOrderEnable.png';
import deleteDisable from './../../resources/assets/images/deleteDisable.png';
import deleteEnable from './../../resources/assets/images/deleteEnable.png';
import filterDisble from './../../resources/assets/images/filter.png';
import filterEnable from './../../resources/assets/images/filterEnable.png';
import iconSplit from './../../resources/assets/images/iconSplit.png';
import order from './../../resources/assets/images/order.png';
import { alertError } from './../../services/dialog';
import history from './../../services/history';
import Pagination from './Pagination';
import './styles.css';
import TableOrderHeader from './TableOrderHeader';
import lang from './../../languages/en';
import { permissions } from './../../constants'
import handlePermission from './../../containers/app/handlePermission'
import iconImportAmazon from './../../resources/assets/images/import_amazon.png'
import StepImportOrder from './../step-import-order'
import { syncOrders, syncLoadingTrue, syncLoadingFalse } from '../../actions/syncAction';
import { getFirstValueObj } from './../../services/helper';
import SplitOrder from '../../containers/orders/components/split-modal'
import { syncValidateOrder } from './../../utils/orders';
import { getChannelImportApi } from './../../utils/channel';
import { ListChannel } from './../../constants/setting_channel';
import hanldeException from '../../services/handleException.js';
import Storage from '../../services/Storage.js';

const confirm = Modal.confirm;
const Status = {
    7: 'Awaiting Finalization',
    8: 'Awaiting Shipment',
    9: 'Sent to Shipment',
    17: 'Split'
}
const TypeStatus = {
    1: 'Imported',
    2: 'Manual',
}
const FulfillmentStatus = {
    2: 'Fulfillment by Yamato',
    1: 'In-House'
}

class TabMenu extends Component {
    state = {
        splitModalVisible: false
    }

    constructor(props) {
        super(props)
        this.state = {
            isShowButtonImportAll: true,
            isActivefailAllChannel: false,
            isAPINotAvailable: false,
            // isImportErrorReason: false,
        }
    }

    componentDidMount() {
        let _that = this;
        getChannelImportApi().then((res) => {

            if (res.data.code == 10001) {
                let listChannelShortName = [];
                let dataChannelMapping = res.data.data;

                for (let i = 0; i < dataChannelMapping.length; i++) {
                    listChannelShortName.push(dataChannelMapping[i].MappingName)
                }

                if (!listChannelShortName.includes(ListChannel.AMAZON_JP.ShortName) && !listChannelShortName.includes(ListChannel.RAKUTEN.ShortName)) {
                    _that.setState({
                        isShowButtonImportAll: false
                    })
                }
            }
        })
    }

    showConfirmDelOrder = (hasSplitedOrder) => {
        if (this.props.listIdCheckedOrders.length === 0) {
            alertError(lang.select_order_delete)
        } else {
            let _this = this
            let content = lang.delete_order_cannot_reimported_or_recovered

            if (hasSplitedOrder) {
                content = (
                    <React.Fragment>
                        {lang.delete_order_cannot_reimported_or_recovered}
                        <br /><br />
                        {lang.splited_orders_delete_warning}
                    </React.Fragment>
                )
            }
            confirm({
                title: lang.confirm_delete_order_has_select,
                cancelText: 'No',
                okText: 'Yes',
                content,
                autoFocusButton: null,
                onOk() {
                    _this.props.deleteOrder(_this.props.listIdCheckedOrders)
                },
                onCancel() { },
            });
        }
    }

    showConfirmDeleteSplitedOrder = () => {
        if (this.props.listIdCheckedOrders.length === 0) {
            alertError(lang.select_order_delete)
        }
        else {
            let _this = this
            confirm({
                title: lang.confirm_delete_order_has_select,
                cancelText: 'No',
                okText: 'Yes',
                content: lang.splited_orders_delete_warning,
                autoFocusButton: null,
                onOk() {
                    _this.props.deleteOrder(_this.props.listIdCheckedOrders)
                },
                onCancel() { },
            });
        }
    }

    toCheckCreateShipment = () => {
        let checkResult = true
        let { FulfillmentFlg } = this.props.Summary
        let { listIdCheckedOrders, listIdCheckedOrdersWithStatus, listIdCheckedOrderWithFulfillOption } = this.props;
        for (let i = 0; i < listIdCheckedOrders.length; i++) {
            if (listIdCheckedOrdersWithStatus[listIdCheckedOrders[i]] !== orderStatus.AWAITING_SHIPMENT) {
                checkResult = false
            }
        }

        let content = lang.warning_when_create_shipment_from_order;
        if (FulfillmentFlg) {
            let countOrderYamato = 0;
            let countOrderInhouse = 0;
            for (let key in listIdCheckedOrderWithFulfillOption) {
                let value = listIdCheckedOrderWithFulfillOption[key];
                if (value === FulfillOption.YAMATO.CODE) {
                    countOrderYamato++;
                } else if (value === FulfillOption.IN_HOUSE.CODE) {
                    countOrderInhouse++;
                }
            }
            content = (
                <div>
                    <p className="content-warning-create-shipment-1">{lang.warning_when_create_shipment_from_order_fulfillment_1}</p>
                    <p className="content-warning-create-shipment-2">{lang.warning_when_create_shipment_from_order_fulfillment_2}</p>
                    <div className="count-popup-confirm-create-shipment">
                        <div className="content-left">
                            <p>Create fulfillment by Yamato shipment: {countOrderYamato}</p>
                            <p>Create in house shipment: {countOrderInhouse}</p>
                        </div>
                    </div>
                </div>
            )
        }

        if (checkResult) {
            let _this = this
            confirm({
                title: lang.confirm_create_shipment_from_order,
                content: content,
                width: 520,
                autoFocusButton: null,
                onOk() {
                    _this.props.createShipment(listIdCheckedOrders)
                },
                onCancel() { },
            });
        } else {
            alertError(lang.warning_select_order_awaiting_shipment)
        }

    }


    msgToCreateShipment() {
        alertError(lang.only_awaiting_shipment_cant_use)
    }

    CheckSelectedToCreateShipment = () => {
        if (this.props.listIdCheckedOrders.length === 0) {
            return true
        }
        let isDisable = false
        this.props.listIdCheckedOrders.map(id => {
            let status = this.props.listIdCheckedOrdersWithStatus[id]
            if (status === orderStatus.AWAITING_FINALIZATION
                || status === orderStatus.SENT_TO_SHIPMENT
                || status === orderStatus.CANCEL
                || status === orderStatus.SPLIT
            ) {
                isDisable = true
                return
            }
        })
        return isDisable;
    }

    msgToDeleteOrder() {
        Modal.warning({
            title: lang.shipment_already_exists,
            content: lang.warning_delete_shipment_after,
            autoFocusButton: null
        });
    }


    CheckSelectedToDelete = () => {
        const { listIdCheckedOrders, orders } = this.props
        if (listIdCheckedOrders.length === 0) {
            return true
        }
        let isDisable = 0
        let hasSplitedOrder = false

        listIdCheckedOrders.map(id => {
            let status = this.props.listIdCheckedOrdersWithStatus[id]
            if (status === orderStatus.SENT_TO_SHIPMENT
                || status === orderStatus.SENT_TO_SHIPMENT_5
                || status === orderStatus.SENT_TO_SHIPMENT_6
                || status === orderStatus.SPLIT
            ) {
                isDisable = true
                return
            }

            const order = orders.find(o => o.ID === id)
            if (order && order.OrderParentID) {
                hasSplitedOrder = true
            }
        })

        if (isDisable) {
            this.msgToDeleteOrder()
        } else {
            this.showConfirmDelOrder(hasSplitedOrder)
        }
    }

    showDrawerCreateOrder = () => {
        this.props.onChange({ value: true, column: 'visibleAddOrder' })
    }

    closeCreateOrder = () => {
        this.props.onChange({ value: false, column: 'visibleAddOrder' })
    }

    renderFilterCount = () => {
        let textArray = []
        {
            let channelFilter = getFirstValueObj(this.props.input_filter.channel, this.props.ordersReducer.listChannel);
            if (channelFilter) {
                textArray.push(
                    'Channel: ' + channelFilter
                )
            }
            if (this.props.input_filter.channel_order_no) {
                textArray.push(
                    'Channel Order: ' + this.props.input_filter.channel_order_no
                )
            }

            this.props.input_filter.type_list.sort(function (a, b) { return a - b }).map((a) => (
                textArray.push(
                    TypeStatus[a] + ' [' + (this.props.filter_count_type[a] || 0) + ']'
                )
            ))
            this.props.input_filter.status_list.sort(function (a, b) { return a - b }).map((a) => (
                textArray.push(
                    Status[a] + ' [' + (this.props.filter_count_status[a] || 0) + ']'
                )
            ))

            if (this.props.input_filter.from) {
                textArray.push(
                    'Order Date From: ' + this.props.input_filter.from
                )
            }
            if (this.props.input_filter.to) {
                textArray.push(
                    'Order Date To: ' + this.props.input_filter.to
                )
            }

            this.props.input_filter.fulfill_option && this.props.input_filter.fulfill_option.sort(function (a, b) { return b - a }).map((a) => {
                textArray.push(
                    FulfillmentStatus[a] + ' [' + (this.props.filter_count_fulfillment && this.props.filter_count_fulfillment[a] && this.props.filter_count_fulfillment[a] ? this.props.filter_count_fulfillment[a] : 0) + ']'
                )
            })
        }
        return textArray.join(', ')
    }

    clickImportFileOrder = () => {
        this.refs.visibleStepImportOrder(true)
    }

    showConfirm = () => {
        let _this = this
        confirm({
            title: lang.confirm_import_new_order,
            autoFocusButton: null,
            content: (
                <span>{lang.confirm_import_new_order_content}</span>
            ),
            onOk() {
                _this.props.syncLoadingTrue();
                syncValidateOrder().then(res => {
                    switch (res.data.code) {
                        case 230001:
                            _this.props.syncLoadingFalse();
                            _this.showConfirmFailImportDueToNotLinkAccountAmz();
                            break;
                        case 230004:
                            _this.props.syncLoadingFalse();
                            _this.showConfirmFailImportRkt();
                            break;
                        case 230002:
                            _this.props.syncLoadingFalse();
                            _this.setState({
                                isActivefailAllChannel: true
                            })
                            break;
                        case 10001:
                            _this.props.syncOrders()
                            break;
                        case 212515:
                            _this.props.syncLoadingFalse();
                            _this.setState({
                                isAPINotAvailable: true
                            })
                            break;
                        case 212513:
                            _this.props.syncLoadingFalse();
                            _this.showConfirmNotAvailableAmz();
                            break;
                        case 212514:
                            _this.props.syncLoadingFalse();
                            _this.showConfirmNotAvailableRkt()
                            break;
                        default:
                            hanldeException(res)
                    }
                }).catch(error => {
                    hanldeException(error)
                })
            },
            onCancel() { },
        });
    }

    openSplitModal = () => {
        if (this.state.splitModalVisible) {
            this.setState({
                splitModalVisible: false
            }, () => {
                this.setState({
                    splitModalVisible: true
                })
            })
        } else {
            this.setState({
                splitModalVisible: true
            })
        }
    }

    closeSplitModal = () => {
        this.setState({
            splitModalVisible: false
        })
    }

    isSplitButtonDisabled = () => {
        const { listIdCheckedOrders, orders } = this.props

        if (listIdCheckedOrders.length === 1) {
            const order = orders.find(order => order.ID === listIdCheckedOrders[0])

            if (order && order.IsSplitOrder) {
                return false
            }
        }

        return true
    }

    isSplitedOrderChecked = () => {
        const { listIdCheckedOrders, listIdCheckedOrdersWithStatus } = this.props

        let isDisable = false
        listIdCheckedOrders.map(id => {
            let status = this.props.listIdCheckedOrdersWithStatus[id]
            if (status === orderStatus.SPLIT) {
                isDisable = true
                return
            }
        })
        return isDisable
    }

    handleisActivefailAllChannel() {
        this.setState({
            isActivefailAllChannel: false
        })
    }

    handleisAPINotAvailable() {
        this.setState({
            isAPINotAvailable: false
        })
    }

    showConfirmFailImportAmz() {
        let _that = this;
        confirm({
            title: lang.confirm_authentication_channel_amazon,
            content: lang.question_confirm_authentication_channel,
            autoFocusButton: null,
            width: 500,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                _that.props.syncOrders()
            },
            onCancel() { },
        });
    }

    showConfirmFailImportRkt() {
        let _that = this;
        confirm({
            title: lang.confirm_authentication_channel_rakuten,
            content: lang.question_confirm_authentication_channel,
            autoFocusButton: null,
            width: 500,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                _that.props.syncOrders()
            },
            onCancel() { },
        });
    }

    showConfirmNotAvailableAmz() {
        let _that = this;
        confirm({
            title: lang.confirm_confirm_not_available_amazon,
            content: lang.question_confirm_authentication_channel,
            autoFocusButton: null,
            width: 600,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                _that.props.syncOrders()
            },
            onCancel() { }
        })
    }

    showConfirmNotAvailableRkt() {
        let _that = this;
        confirm({
            title: lang.confirm_confirm_not_available_rakuten,
            content: lang.question_confirm_authentication_channel,
            autoFocusButton: null,
            width: 600,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                _that.props.syncOrders()
            },
            onCancel() { }
        })
    }

    showConfirmFailImportDueToNotLinkAccountAmz() {
        let _that = this;
        confirm({
            title: lang.confirm_not_link_account_channel_amazon,
            content: lang.question_confirm_link_account_channel_amazon,
            autoFocusButton: null,
            width: 500,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                history.push('/setting/channel');
            },
            onCancel() {
                _that.showConfirmFailImportAmz();
            },
        });
    }

    redirectSettingChannel(e) {
        e.preventDefault();
        history.push('/setting/channel');
    }

    render() {
        let styleFilter = {
            width: '100%',
            height: '100%',
            background: this.props.add_filter ? '#474747' : '#ffffff',
            color: this.props.add_filter ? '#ffffff' : '#000000',
        }
        let btnCreateShipment = this.CheckSelectedToCreateShipment()
        let style = { width: '100%', height: '100%', background: '#ffffff' }
        let styleDisable = { width: '100%', height: '100%', background: '#eeeeee' }
        let listIdOrders = this.props.orders.map(order => order.ID)

        let StringSelect
        let StringDisplay
        if (this.props.listIdCheckedOrders.length > 1) {
            StringSelect = 'orders selected'
        } else { StringSelect = 'order selected' }
        if (this.props.order_count > 1) {
            StringDisplay = 'orders displayed'
        } else { StringDisplay = 'order displayed' }

        let menuImportOrder = (
            <Menu>
                {
                    handlePermission(permissions.OrderSync) && this.state.isShowButtonImportAll && (<Menu.Item key="1" onClick={() => this.showConfirm()}>Import from ALL Shops</Menu.Item>)
                }
                {handlePermission(permissions.ImportUpload) && (<Menu.Item key="2" onClick={this.clickImportFileOrder}>Import from File</Menu.Item>)}
            </Menu>
        )

        const deleteButtonDisabled =
            this.props.listIdCheckedOrders.length === 0
            || !handlePermission(permissions.OrderDelete)
            || this.isSplitedOrderChecked()

        return (
            <div id="tab-menu">
                <Modal
                    className="popup-dialog"
                    visible={this.state.isActivefailAllChannel}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => this.handleisActivefailAllChannel()}>
                            OK
                        </Button>,
                    ]}
                >
                    {lang.confirm_authentication_fail_allchannel_content}<a onClick={(e) => this.redirectSettingChannel(e)}>E-Commerce Channels</a>.
                </Modal>
                <Modal
                    className="popup-dialog"
                    visible={this.state.isAPINotAvailable}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => this.handleisAPINotAvailable()}>
                            OK
                        </Button>,
                    ]}
                >
                    {lang.confirm_api_not_available_content}
                </Modal>
                <Row>
                    <Col span={9}>
                        <div className="pull-left filter-add">
                            {handlePermission(permissions.ImportUpload) && handlePermission(permissions.OrderSync) ?
                                <div className="icon-import-order">
                                    <Tooltip placement="topLeft" title="Import from ALL Shops">
                                        <Button
                                            disabled={!this.state.isShowButtonImportAll}
                                            style={{ marginLeft: 8 }}
                                            className='button-import-order-with-api'
                                            onClick={() => this.showConfirm()}
                                        >
                                            <img id='icon-import-amazon' src={iconImportAmazon} />
                                        </Button>
                                    </Tooltip>
                                    <Dropdown
                                        overlay={menuImportOrder}
                                        trigger={['click']}
                                    >
                                        <Button
                                            className='list-type-import-order'
                                        >
                                            <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </div>
                                : ''}
                            {handlePermission(permissions.OrderAddShipmentAndPackage) ?
                                <div className="icon action big-icon" id="create-shipment">
                                    <Tooltip placement="top" title="Create Shipment">
                                        <Button
                                            className="btn-create-ship"
                                            style={btnCreateShipment ? styleDisable : style}
                                            size={'small'}
                                            onClick={() =>
                                                this.toCheckCreateShipment()
                                            }
                                            disabled={btnCreateShipment ? true : false}
                                        >
                                            <img src={btnCreateShipment ? addOrderDis : addOrderEna} style={{ margin: '1' }} />
                                        </Button>
                                    </Tooltip>
                                </div>
                                : ''}
                            {handlePermission(permissions.OrderSplitOrder) ?
                                <div className="icon action" id="split-order">
                                    <Tooltip title="Split Order">
                                        <Button
                                            style={this.isSplitButtonDisabled() ? styleDisable : style}
                                            className="split-button no-padding "
                                            size={'small'}
                                            onClick={this.openSplitModal}
                                            disabled={this.isSplitButtonDisabled()}
                                        >
                                            <img src={iconSplit}
                                                style={
                                                    this.isSplitButtonDisabled() ? { opacity: '0.5' } : {}
                                                }
                                            />
                                        </Button>
                                    </Tooltip>
                                </div>
                                : ''}
                            {handlePermission(permissions.OrderCreateNewOrder) ?
                                <div className="icon action" id="create-order">
                                    <Tooltip placement="topLeft" title="Create new order">
                                        <Button
                                            style={style}
                                            className="no-padding "
                                            size={'small'}
                                            onClick={() => history.push('/orders/add')}
                                        >
                                            <img src={order} />
                                        </Button>
                                    </Tooltip>
                                </div>
                                : ''}
                            {handlePermission(permissions.OrderDelete) ?
                                <div className="icon action">
                                    <Tooltip placement="top" title="Delete">
                                        <Button
                                            style={deleteButtonDisabled ? styleDisable : style}
                                            size={'small'}
                                            onClick={this.CheckSelectedToDelete}
                                            disabled={deleteButtonDisabled ? true : false}
                                        >
                                            <img src={deleteButtonDisabled ? deleteDisable : deleteEnable} style={{ width: '85%' }} />
                                        </Button>
                                    </Tooltip>
                                </div>
                                : ''}
                            <div className={this.props.add_filter ? "icon" : "icon action"}>
                                <Tooltip placement="top" title="Add Filter">
                                    <Button
                                        style={styleFilter} size={'small'} className={"no-padding"}
                                        onClick={() => this.props.addFilter()} >
                                        <img src={this.props.add_filter ? filterEnable : filterDisble} style={{ width: '85%' }} />
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                    </Col>
                    <Col className="result" span={5} style={{ textAlign: "center" }}>
                        <div>
                            <span>{this.props.order_count || 0} {StringDisplay} - {this.props.listIdCheckedOrders.length || 0} {StringSelect}</span>

                        </div>
                    </Col>
                    <Pagination />
                    <AddFilter />
                    <Col className="quickfilter" span={24} style={{ display: 'inline-flex' }}>
                        Filters:&nbsp;
                        {this.renderFilterCount()}
                    </Col>
                </Row>
                <TableOrderHeader />
                <StepImportOrder ref={refs => this.refs = refs} />
                {
                    this.state.splitModalVisible && (
                        <SplitOrder
                            visible={this.state.splitModalVisible}
                            onCancel={this.closeSplitModal}
                        />
                    )
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        orders: state.ordersReducer.orders,
        add_filter: state.ordersReducer.add_filter,
        listIdCheckedOrdersWithStatus: state.ordersReducer.listIdCheckedOrdersWithStatus,
        listIdCheckedOrderWithFulfillOption: state.ordersReducer.listIdCheckedOrderWithFulfillOption,
        input_filter: state.ordersReducer.input_filter,
        order_count: state.ordersReducer.order_count,
        filter_count_status: state.ordersReducer.filter_count_status,
        filter_count_type: state.ordersReducer.filter_count_type,
        filter_count_fulfillment: state.ordersReducer.filter_count_fulfillment,
        listIdCheckedOrders: state.ordersReducer.listIdCheckedOrders,
        ordersReducer: state.ordersReducer,
        splitEnabled: state.ordersReducer.splitEnabled,
        listCheckedOrders: state.ordersReducer.listCheckedOrders,
        loading: state.syncReducer.loading,
        Summary: state.headerReducer.Summary
    }

}

const mapDispatchToProps = dispatch => {
    return {
        addFilter: conditions => {
            dispatch(addFilter(conditions))
        },
        createShipment: payload => {
            dispatch(createShipment(payload))
        },
        deleteOrder: payload => {
            dispatch(deleteOrder(payload))
        },
        syncOrders: () => {
            dispatch(syncOrders())
        },
        syncLoadingTrue: () => {
            dispatch(syncLoadingTrue())
        },
        syncLoadingFalse: () => {
            dispatch(syncLoadingFalse())
        },

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TabMenu)



// WEBPACK FOOTER //
// ./src/components/tab-menu/index.js